<template>
  <div>
    <v-col cols="12">
      <v-dialog v-model="openMap" activator="parent" class="p-10" max-width="400">
        <v-card>
          <v-toolbar color="primary" dark>
            <v-toolbar-title>ویژگی ها</v-toolbar-title>
            <v-spacer/>
            <v-toolbar-items>
              <v-btn icon @click="openMap = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <extra-shown v-model="value.extra" class="pa-4"/>
        </v-card>
      </v-dialog>

      <v-card class="overflow-hidden" shaped>
        <v-card-title class="p-0">
          <intro-slider :is-slider="false" :value="computedBanner"/>
        </v-card-title>
        <v-card-text class="mt-4 px-0">
          <div class="mx-auto d-flex">
            <div class="col-md-8 pa-2 d-flex align-center">
              <h6 class="font-weight-bold ma-0">{{ value.name }}</h6>
            </div>
            <div class="col-md pa-0 text-left">
              <v-btn class="mr-auto" icon @click="openMap = true">
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </div>
          </div>
          <div class="col-md-12">
            <pre class="text-right my-0" v-text="trancateTxts"/>
            <v-btn v-if="value.description.length > 100"
                   class="ms-n4" color="primary" text @click="isTruncate = !isTruncate">
              {{ isTruncate ? 'مشاهده بیشتر' : 'مشاهده کمتر' }}
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-col>
  </div>
</template>

<script>
import IntroSlider from "@/view/pages/businessPage/components/view/bIntroSliderView";
import ExtraShown from "./extraShown";

export default {
  name: "adsCard",

  components: {ExtraShown, IntroSlider},

  props: {
    value: Object
  },

  data() {
    return {
      isTruncate: true,
      openMap: false
    }
  },

  computed: {
    hasGallery() {
      let gallery = this.value.gallery
      !!gallery && typeof gallery === 'string' && (gallery = JSON.parse(gallery))
      // return this.value.gallery?.length > 0 && this.value.gallery?.filter(item => item.images?.length > 0)?.length > 0
    },
    computedBanner() {
      if (this.hasGallery)
        return {
          banner: this.value.gallery[0]
        }
      else {
        return null
      }
    },
    trancateTxts() {
      let about = this.value.description;

      const more = about.split("<div>").length > 3;

      const text = () => {
        let variable = about.split('<div>');
        let generatedText = ''
        for (let a = 0; a <= 3; a++) {
          generatedText += '<div>' + variable[a]
        }
        return generatedText;
      };

      about = ((about.length > 100 || more) && this.isTruncate) ? (more ? text() : about.slice(0, 100)) + '&hellip;' : about;

      return about
        .replace(/style="width:604px;height:270px" /gms, 'style="width:100%;height:auto"')
        .replace(/style="display: block;padding-top: 57%"/gms, '')
      // return about.replace(/<div class="h_iframe-.*<iframe/gms, '<iframe ').replace(/ style="width:604px;height:270px" /gms, '');
    },
  }
}
</script>

<style scoped>
pre {
  font-family: Vazir, serif !important;
  white-space: break-spaces;
  overflow: hidden;
}
</style>